import Vue from "vue";
export var DialogJobEventBus = new Vue();